import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import _ from 'lodash-es';
import Popup from '../../../../../Common/Popup/Popup';
import { CustomDynamicForm } from '../../../../../Common/CustomForm/CustomDynamicForm';
import { getLumpingFaciltyReducer } from '../../../../../../../redux/reducers/reducerSlices/GetLumpingFaciltyReducer';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { sortArrByKey } from '../../../../../../Assests/Utility';
import { YYYY_MM_DD_FORMAT, getFormattedDate, changeDateToGivenFormat, getCurrentDate } from '../../../../../../../Utils/DateUtils';
import DownloadSection from '../../../DownloadSection/DownloadSection';
import { usePrevious } from '../../../../../Common/CustomHooks/usePrevious';
import TruckUnloadStatisticsList from './ListComponent/TruckUnloadStatisticsList';
import { getDockListSelector } from '../../../../../../../redux/reducers/reducerSlices/DockListReducer';
import ReportsInput from '../Components/ReportsInputs';
import './TruckUnloadStatistics.css';
import moment from 'moment';

const TruckUnloadStatistics = (props) => {
    const dispatch = useDispatch();
    const { themeSelected } = props;
    const [showModal, setShowModal] = useState(false);
    const lumpingFacilityData = useSelector(getLumpingFaciltyReducer);
    const user = useSelector(getUserSelector);
    const { userType, parentWarehouse } = user;
    const [lumpingFacDataArr, setLumpingFacDataArr] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [warehouseListState, setWarehouseListState] = useState([]);
    const [loading, setLoading] = useState(false);
    const divRef = useRef(null);
    const [currentTable, setCurrentTable] = useState(null);
    const [currentTableRef, setCurrentTableRef] = useState(null);
    const previousTable = usePrevious(currentTable);
    const getDockList = useSelector(getDockListSelector);
    const { dockList } = getDockList;
    const [editData, setEditData] = useState({});
    const [apiParams, setApiParams] = useState([]);
    const [dockListArr, setDockListArr] = useState([]);
    const [particularFieldValue, setParticularFieldValue] = useState("");
    const [startDateState, setStartDateState] = useState(changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat))
    const [endDateState, setEndDateState] = useState(changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat))
    const [showDateRange, setShowDateRange] = useState(false);
    const [showWeeklyDateRange, setShowWeeklyDateRange] = useState(false);
    const [startTimeState, setStartTimeState] = useState(new Date());
    const [endTimeState, setEndTimeState] = useState(new Date());
    const [currentCustomCalendarType, setCurrentCustomCalendarType] = useState('today');
    const [currentCalendarType, setCurrentCalendarType] = useState('');
    const [onDockValue, setOnDockValue] = useState('');

    useEffect(() => {
        const container = divRef.current;
        const tables = container.querySelectorAll('table');
        if (tables && tables.length && _.isEqual(currentTable, previousTable)) {
            setCurrentTableRef(container);
            setCurrentTable(tables);
        }
    })

    useEffect(() => {
        setWarehouseListState([])
        setLumpingFacDataArr([])
        setDockListArr([])
        setShowModal(true);
        const { userPermission } = AppConstant;
        dispatch({ type: sagaActions.GET_LUMPING_FACILTY_DATA });
        if (userType === userPermission.usertypes.user) {
            setWarehouseListState([parentWarehouse])
            dispatch({ type: sagaActions.DOCK_LIST, payload: { warehouse_id: parentWarehouse.ID } })
            setParticularFieldValue({ warehouse_id: parentWarehouse.ID, lumping_facility_id: parentWarehouse.IDLumpingFacility, on_dock: 'False' });
        }
        dispatch({ type: sagaActions.CLEAR_TRUCK_UNLOAD_STATS_LIST });
    }, [])

    useEffect(() => {
        if (lumpingFacilityData.data) {
            const { IDLumpingFacility } = parentWarehouse;
            const tempArr = lumpingFacilityData.data.filter(el => el.ID === IDLumpingFacility)
            setLumpingFacDataArr(tempArr);
        }
    }, [lumpingFacilityData.data])

    useEffect(() => {
        if (_.size(dockList)) {
            let dockListtemp = [{ dock_id: AppConstant.reports.master_id_all, dock_name: 'ALL' }, ...dockList]
            setDockListArr(dockListtemp)
        }
    }, [dockList])

    const getLumpingFacilityList = () => {
        return (
            lumpingFacDataArr &&
            lumpingFacDataArr.map((data, index) => {
                return (
                    <option key={data.ID} value={data.ID}>
                        {data.Description}
                    </option>
                );
            })
        );
    };

    const getWarehousesList = () => {
        return (
            warehouseListState &&
            warehouseListState.map((data, index) => {
                return (
                    <option key={data.ID} value={data.ID}>
                        {data.Name}
                    </option>
                );
            })
        );
    };

    const getDocksList = () => {
        return (
            dockListArr &&
            dockListArr.map((data, index) => {
                return (
                    <option key={data.dock_id} value={data.dock_id}>
                        {data.dock_name}
                    </option>
                );
            })
        );
    };

    const TUSCustomInput = forwardRef(({ value, onClick }, ref) => (
        <button className="customDatePickerInput" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const getFormFieldData = (data, name) => {
        if (!name || typeof name !== 'string') return;
        if (data === undefined || data === null) return;
        if (name === 'period_id') {
            const periodValue = data?.toUpperCase();

            if (periodValue === 'CUSTOM') {
                setShowDateRange(true);
                setShowWeeklyDateRange(false);
                setCurrentCalendarType(data);
                setParticularFieldValue(prev => ({
                    ...prev,
                    period_id: data,
                    'custom-date-picker': ''
                }));
                setSelectedDate('');
            } else {
                setShowDateRange(false);
                setShowWeeklyDateRange(true);
                setCurrentCalendarType(data);


                setParticularFieldValue(prev => ({
                    ...prev,
                    period_id: data,
                    'custom-date-picker': ''
                }));
                setSelectedDate('');

            }
            return;
        }

        if (name === 'start_date') {
            setStartDateState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                start_date: data,
                end_date: '' // reset end date when start date changes
            }));
        } else if (name === 'end_date') {
            setEndDateState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                end_date: data
            }));
        } else if (name === 'custom-date-picker') {
            const formattedDate = changeDateToGivenFormat(
                data,
                AppConstant.commonStrings.MM_DD_YYYY_dateFormat
            );
            setShowDateRange(false);
            setShowWeeklyDateRange(true);
            setSelectedDate(formattedDate);
            setParticularFieldValue(prev => ({
                ...prev,
                'custom-date-picker': formattedDate
            }));
        } else if (name === 'start_time') {
            setStartTimeState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                start_time: data
            }));
        } else if (name === 'end_time') {
            setEndTimeState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                end_time: data
            }));
        } else if (name === 'on_dock') {
            // const booleanValue = (data === 'true' || data === true);
            setOnDockValue(data);
            setParticularFieldValue(prev => ({
                ...prev,
                on_dock: data
            }));
        }


        if (name === 'warehouse_id') {
            setSelectedWarehouse(_.find(warehouseListState, { ID: data }))
        }
        // if (name === 'custom-date-picker') {
        //     setSelectedDate(changeDateToGivenFormat(data, AppConstant.commonStrings.MM_DD_YYYY_dateFormat))
        // }
    };

    const getSummitedFormData = (data) => {
        if (!data || typeof data !== 'object') {
            return;
        }

        if (!data.start_date) {
            data.start_date = new Date();
        }
        if (!data.end_date) {
            data.end_date = new Date();
        }

        const apiParams = {
            "IDLumpingFacility": data.lumping_facility_id,
            "IDWarehouse": data.warehouse_id,
            "PeriodType": data.period_id,
            "dock_id": data.dock_id === AppConstant.reports.master_id_all ? null : data.dock_id,
            "Date": data?.period_id.toUpperCase() != 'CUSTOM' ? getFormattedDate(YYYY_MM_DD_FORMAT, data['custom-date-picker']) : null,
            "onDock": particularFieldValue?.on_dock === 'True' ? true : false,
            "startDate": data?.period_id.toUpperCase() === 'CUSTOM' ? combineDateAndTime(data?.start_date, data?.start_time, true) : null,
            "endDate": data?.period_id.toUpperCase() === 'CUSTOM' ? combineDateAndTime(data?.end_date, data?.end_time, true) : null,
        }

        const selectedLumper = (_.find(lumpingFacDataArr, { ID: data.lumping_facility_id }));
        const selectedWarehouse = (_.find(warehouseListState, { ID: data.warehouse_id }));
        const selectedDock = (_.find(dockListArr, { dock_id: data.dock_id }));

        const paramsArr =
            [{ "Lumping Facility ": selectedLumper.Description ? selectedLumper.Description : '' },
            { "Warehouse": selectedWarehouse.Name ? selectedWarehouse.Name : '' },
            { "Time Period": 'Weekly' },
            { "Dock": selectedDock.dock_name ? selectedDock.dock_name : '' },
            { "Date": data['custom-date-picker'] ? changeDateToGivenFormat(data['custom-date-picker'], AppConstant.commonStrings.MM_DD_YYYY_dateFormat) : '' }
            ];

        if (data.period_id.toUpperCase() === 'CUSTOM') {
            paramsArr.push(
                { "Start Date": data?.start_date ? combineDateAndTime(data?.start_date, data?.start_time, false) : '' },
                { "End Date": data?.end_date ? combineDateAndTime(data?.end_date, data?.end_time, false) : '' },
            );
        }

        if (particularFieldValue?.on_dock !== undefined) {
            paramsArr.push(
                { "On Dock": String(particularFieldValue?.on_dock) }
            );
        }

        setApiParams(paramsArr);

        dispatch({ type: sagaActions.INTIATE_LOADER_REPORTS, payload: true });
        dispatch({ type: sagaActions.GET_TRUCK_UNLOAD_STATS_LIST, payload: apiParams });
        setLoading(true)
        setShowModal(false);
    };

    const getTimePeriodList = () => {
        const timePeriodArr = ['Weekly', 'Custom']
        return (
            timePeriodArr &&
            timePeriodArr.map((data, index) => {
                return (
                    <option key={data} value={data}>
                        {data}
                    </option>
                );
            })
        );
    };

    const getOnDockOptions = () => {
        return [
            { value: 'True', label: 'True' },
            { value: 'False', label: 'False' },
        ].map(opt => <option key={String(opt.value)} value={opt.value}>{opt.label}</option>);
    };

    const combineDateAndTime = (date, time, addTimeZone) => {
        if (!date || !time) return null;

        // Extract date and time parts separately
        const datePart = moment(date).format('YYYY-MM-DD');

        // Convert to UTC and format
        if (addTimeZone) {
            return `${datePart}T${time}:00Z`;
        }
        return `${moment(date).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)} ${time}`;
    };

    const TUSDatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <button className="customDatePickerInput" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const TUSTimePickerInput = forwardRef(({ value, onClick }, ref) => {
        let dateStr = moment(value).hours() + ':' + moment(value).minutes();
        if (!value.includes('mm')) {
            const getHour = ("0" + moment(value).hour()).slice(-2);
            const getMin = ("0" + moment(value).minutes()).slice(-2);
            dateStr = getHour + ":" + getMin;
        }

        return (
            <button className="customDatePickerInput" onClick={onClick} ref={ref}>
                {dateStr !== 'NaN:NaN' ? dateStr : 'HH:MM'}
            </button>
        )
    });

    const formFieldList = [
        {
            name: "lumping_facility_id",
            type: "select",
            size: "col-sm-6",
            position: 1,
            title:
                AppConstant.reports.truckUnloadSummaryReport.selectLumpingFacility,
            formValidation: {
                required: true,
            },
            getSelectData: getLumpingFacilityList,
        },
        {
            name: "warehouse_id",
            type: "select",
            size: "col-sm-6",
            position: 1,
            title:
                AppConstant.reports.truckUnloadSummaryReport.warehouse,
            formValidation: {
                required: true,
            },
            getSelectData: getWarehousesList,
        },
        {
            name: "dock_id",
            type: "select",
            size: "col-sm-6",
            position: 2,
            title:
                AppConstant.reports.truckUnloadStatisticsReport.selectDock,
            formValidation: {
                required: true,
            },
            getSelectData: getDocksList,
        },
         {
            name: "on_dock",
            type: "select",
            size: "col-sm-6",
            position: 2,
            title: "On Dock",
            value: onDockValue, // Add this line
            formValidation: {
                required: false,
            },
            getSelectData: getOnDockOptions,
        },
        {
            name: "period_id",
            type: "select",
            size: "col-sm-6",
            position: 3,
            title:
                AppConstant.reports.truckUnloadSummaryReport.selectTimePeriod,
            formValidation: {
                required: true,
            },
            getSelectData: getTimePeriodList,
        },
        {
            size: "col-sm-6 mt-1",
            name: "custom-date-picker",
            type: "custom-date-picker",
            customDatePickerConfig: {
                calendarType: currentCalendarType,
                selectedDate: selectedDate ? selectedDate : AppConstant.commonStrings.MM_DD_YYYY_dateFormat,
                customInput: <TUSCustomInput />,
            },
            position: 3,
            value: selectedDate,
            title:
                AppConstant.reports.truckUnloadStatisticsReport.selectDate,
            formValidation: {
                required: showWeeklyDateRange,
            },
            hideElement: {
                isHidden: showWeeklyDateRange
            }
        },
        {
            size: "col-sm-6 mt-1",
            name: "start_date",
            type: "custom-date-picker",
            customDatePickerConfig: {
                name: "start_date",
                calendarType: currentCustomCalendarType,
                selectedDate: startDateState,
                customInput: <TUSDatePickerInput />
            },
            position: 4,
            value: startDateState,
            title:
                AppConstant.reports.truckUnloadSummaryReport.startDate,
            formValidation: {
                required: showDateRange,
            },
            hideElement: {
                isHidden: showDateRange
            }
        },
        {
            size: "col-sm-6 mt-1",
            name: "end_date",
            type: "custom-date-picker",
            customDatePickerConfig: {
                name: "end_date",
                calendarType: currentCustomCalendarType,
                selectedDate: endDateState,
                startDate: startDateState,
                maxDate: startDateState ? moment(startDateState).add(1, 'months').toDate() > moment().toDate() ? new Date() : moment(startDateState).add(1, 'months').toDate() : null,
                minDate: startDateState ? new Date(startDateState) : null,
                customInput: <TUSDatePickerInput />
            },
            position: 4,
            value: endDateState,
            title:
                AppConstant.reports.truckUnloadSummaryReport.endDate,
            formValidation: {
                required: showDateRange,
            },
            hideElement: {
                isHidden: showDateRange
            }
        },
        {
            size: "col-sm-6 mt-1",
            name: "start_time",
            type: "custom-time-selector", // <-- you'll define this
            customDatePickerConfig: {
                name: "start_time",
                showTimeSelect: true,
                showTimeSelectOnly: true,
                selectedDate: startTimeState,
                timeIntervals: 30,
                timeCaption: "Time",
                customInput: <TUSTimePickerInput value={startTimeState} />
            },
            position: 5,
            value: startTimeState ? startTimeState : "",
            title: "Start Time",
            formValidation: {
                required: showDateRange,
            },
            hideElement: {
                isHidden: showDateRange
            }
        },
        {
            size: "col-sm-6 mt-1",
            name: "end_time",
            type: "custom-time-selector", // <-- you'll define this
            customDatePickerConfig: {
                name: "end_time",
                selectedDate: endTimeState,
                showTimeSelect: true,
                showTimeSelectOnly: true,
                timeIntervals: 30,
                timeCaption: "Time",
                customInput: <TUSTimePickerInput value={endTimeState} />
            },
            position: 5,
            value: endTimeState ? endTimeState : "",
            title: "End Time",
            formValidation: {
                required: showDateRange,
            },
            hideElement: {
                isHidden: showDateRange
            }
        }
    ]

    const closepopup = () => {
        setEditData({});
        setShowModal(false);
        setStartDateState('')
        setEndDateState('')
    }

    const submitbtnData = {
        show: true,
        text: AppConstant.reports.generateReportButtonTitle,
    };
    const cancelbtndata = {
        show: true,
        text: AppConstant.comments.resetbutton,
    };

    const createForm = () => {
        return (
            <CustomDynamicForm
                formFieldList={formFieldList}
                sort={true}
                cancelBtn={cancelbtndata}
                submitbtn={submitbtnData}
                themeSelected={themeSelected}
                getSummitedFormData={getSummitedFormData}
                getFormFieldData={getFormFieldData}
                editFormData={editData}
                setParticularFieldValue={particularFieldValue}
                loading={loading}
            />
        );
    };

    const popupObj = {
        id: "createWarehouseFormPopup1",
        modalLabel: "createWarehouseFormPopup1",
        showClose: true,
        showfooter: true,
        showHeader: true,
        sendDriverNotification: false,
        modalSize: "xl",
        title: AppConstant.reports.truckUnloadStatisticsReport.createReport,
        bodyText: createForm(),
        subText: "",
        keyboard: false,
        backdrop: "static",
        footerBtn: {
            btn1: {
                show: true,
                text: AppConstant.comments.cancelCommentButtonTitle,
            },
            btn2: {
                show: true,
                text: AppConstant.reports.generateReportButtonTitle,
            },
        },
    };

    function showPopup() {
        setStartDateState('')
        setEndDateState('')
        setStartTimeState('')
        setEndTimeState('')
        setShowModal(true);
        setCurrentCalendarType('');
        setParticularFieldValue({});
        setTimeout(() => {
            setParticularFieldValue({ warehouse_id: parentWarehouse.ID, lumping_facility_id: parentWarehouse.IDLumpingFacility, on_dock: 'False' });
        }, 100)
        setShowDateRange(false);
        setShowWeeklyDateRange(false);
        setApiParams([]);
        dispatch({ type: sagaActions.CLEAR_TRUCK_UNLOAD_STATS_LIST });
        setSelectedDate(AppConstant.commonStrings.MM_DD_YYYY_dateFormat);
        setTimeout(() => {
        setParticularFieldValue({ warehouse_id: parentWarehouse.ID, lumping_facility_id: parentWarehouse.IDLumpingFacility });
        }, 100)
    }

    return (
        <div className="pt-2">

            <div className='container-fluid d-flex py-2 text-start justify-content-between'>
                <button
                    className={'addButton'}
                    onClick={() => showPopup()}
                >
                    {
                        AppConstant.reports.truckUnloadStatisticsReport.createReport
                    }
                </button>
                <div className='d-flex align-items-center'>
                    <DownloadSection root={''} subRoot={''} name={'Truck Unload Statistics Report'} themeSelected={themeSelected} currentTable={currentTable} currentTableRef={currentTableRef} singlePageDownload={true} />
                </div>
            </div>

            <div className="mt-1">
                <Popup
                    {...popupObj}
                    showModal={showModal}
                    showfooter={false}
                    closepopup={closepopup}
                    themeSelected={themeSelected}
                />
            </div>

            <div ref={divRef} className='truckUnloadStatsTable'>
                {
                    (apiParams && apiParams.length) ?
                        <div>
                            <div className="mx-2 container-fluid text-center graphHeading">{AppConstant.reports.truckUnloadStatisticsReport.title}</div>
                            <ReportsInput apiParams={apiParams} />
                            <TruckUnloadStatisticsList selectedDate={selectedDate} selectedWarehouse={selectedWarehouse} loading={loading} setLoading={setLoading} />
                        </div>
                        :
                        <div />
                }
            </div>
        </div>
    );

}

export default TruckUnloadStatistics;
